<template>
    <div id="management">
        <management-filter @filter-data="filterData" :technicians="technicians"/>
        <management-index :filter="filter"
                          :selectedInterventions="cart ? cart.interventions : []"
                          :cartIsReady="cartIsReady"
                          :cartStored="cartStored"
                          @update-cart-interventions="updateCartInterventions"
                          @updating="updating = true"
                          @loaded="updating = false"
                          @table-loaded="tableLoaded"/>
        <management-cart :cart="cart"
                         :technicians="technicians"
                         :cartIsReady="cartIsReady"
                         :plannedDay="plannedDay"
                         @get-new-cart="getNewCart"
                         @reset-cart="resetCart"
                         @update-cart-settings="updateCartSettings"
                         @updating="updating = true"
                         @loaded="updating = false"/>
        <management-map :displayedTableRows="displayedTableRows"
                        :cart="cart"
                        :cartIsReady="cartIsReady"
                        @update-cart-interventions="updateCartInterventions"/>
        <div class="calendar-overlay" :class="updating ? 'opacity-100 fixed z-50 w-full h-full' : 'opacity-0 absolute z-0 w-0 h-0'">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import ManagementFilter from './components/ManagementFilter'
import ManagementIndex from "./components/ManagementIndex"
import ManagementCart from "./components/ManagementCart"
import ManagementMap from "./components/ManagementMap"

export default {
    name: "Management",
    components: {
        ManagementIndex,
        ManagementFilter,
        ManagementCart,
        ManagementMap
    },
    data() {
        return {
            technicians: [],
            filter: {},
            cartStructure: {
                hasFixedInterventions: false,
                technician: null,
                date: this.$moment().format('YYYY-MM-DD'),
                departureTime: '08:00',
                firstTravel: {
                    departureTime: '08:00',
                    calculatedDuration: null,
                    duration: null,
                    comment: '',
                    element_planningable_id: ''
                },
                interventions: [],
                lastTravel: {
                    departureTime: '17:00',
                    calculatedDuration: null,
                    duration: null,
                    comment: '',
                    element_planningable_id: ''
                }
            },
            cart: null,
            cartStored: 0,
            updating: true,
            plannedDay: {},
            displayedTableRows: [],
        }
    },
    methods: {
        tableLoaded (e) {
            this.updating = false
            this.displayedTableRows = e
        },
        filterData(data) {
            this.updating = true
            this.filter = {...data}
        },
        updateCartInterventions(e) {
            const oldCart = _.cloneDeep(this.cart)
            if (e.checked) {
                const intervention = {
                    intervention: e,
                    isUpdatable: true,
                    lunchBreak: false
                }
                this.cart.interventions ? this.cart.interventions.push(intervention) : this.cart.interventions = [intervention]
            } else {
                // Handle previsions and one times
                if (e.prevision_id) {
                    this.cart.interventions = this.cart.interventions.filter((item) => { return item.intervention.prevision_id !== e.prevision_id || (item.intervention.prevision_id === e.prevision_id && item.intervention.year !== e.year) })
                } else {
                    this.cart.interventions = this.cart.interventions.filter(item => item.intervention.intervention_id !== e.intervention_id)
                }
            }
            if (this.cart.interventions.length > 0) {
                this.getCartTravelTimes(this.cart, oldCart)
            } else {
                this.cart.interventions = []
                localStorage.setItem('management-prevision-cart', JSON.stringify(this.cart))
                this.updating = false
            }
        },
        async getNewCart(cart) {
            try {
                //If technician and date are set, get a new cart
                if (this.cart.technician && this.cart.date) {
                    this.cart.interventions = []
                    const { data } = await this.$store.dispatch('planningManagement/getNewCart', { cart: cart })
                    this.cart = data.cart
                    this.plannedDay = data.plannedDay
                    if (data.googleMapsApiError) {
                        await this.$store.dispatch('alerts/error', 'Le calcul du temps de trajet a échoué, veuillez vérifier que les coordonnées de chaque site sont correctes. Sinon, contactez le support.')
                    }
                }
                if (this.cart === undefined) {
                    this.resetCart()
                    await this.$store.dispatch('alerts/error', 'Une erreur est survenue, le panier a été écrasé. Si le problème est récurrent, veuillez contacter le support.')
                }
                localStorage.setItem('management-prevision-cart', JSON.stringify(this.cart))
                this.updating = false
            } catch {
                this.updating = false
            }
        },
        updateCartSettings(cart) {
            if (cart.interventions.length > 0) {
                this.getCartTravelTimes(cart)
            } else {
                localStorage.setItem('management-prevision-cart', JSON.stringify(cart))
                this.updating = false
            }
        },
        resetCart() {
            this.cart = _.cloneDeep(this.cartStructure)
            this.plannedDay = {}
            this.updating = false
            this.cartStored++
            localStorage.setItem('management-prevision-cart', JSON.stringify(this.cart))
        },
        async getCartTravelTimes(cart, oldCart = null) {
            try {
                const {data} = await this.$store.dispatch('planningManagement/getCartTravelTimes', {cart: cart})
                this.cart = data.cart
                if (this.cart === undefined) {
                    this.resetCart()
                    await this.$store.dispatch('alerts/error', 'Une erreur est survenue, le panier a été écrasé. Si le problème est récurrent, veuillez contacter le support.')
                }
                localStorage.setItem('management-prevision-cart', JSON.stringify(this.cart))
                this.updating = false
                if (data.googleMapsApiError) {
                    await this.$store.dispatch('alerts/error', 'Le calcul du temps de trajet a échoué, veuillez vérifier que les coordonnées de chaque site sont correctes. Sinon, contactez le support.')
                }
            } catch {
                if (oldCart !== null) {
                    this.cart = _.cloneDeep(oldCart)
                }
                this.updating = false
            }
        },
        async getTechnicians() {
            const {data: technicians} = await this.$store.dispatch('users/fetchActiveTechnicians')
            this.technicians = technicians
        },
        async getPlannedDay() {
            this.$emit('updating')
            const { data } = await this.$store.dispatch('planningManagement/getPlannedDay', { cart: this.cart })
            this.plannedDay = data
            this.$emit('loaded')
        },
    },
    computed: {
        cartIsReady() {
            return (this.cart && this.cart.technician !== null && this.cart.date !== null)
        }
    },
    async mounted() {
        bus.$emit('minimise-sidebar')
        await this.getTechnicians()
        let cart = localStorage.getItem('management-prevision-cart')
        if (cart !== undefined) {
            this.cart = JSON.parse(localStorage.getItem('management-prevision-cart')) ?? _.cloneDeep(this.cartStructure)
        } else {
            // Reset cart if broken
            this.resetCart()
            await this.$store.dispatch('alerts/error', 'Une erreur est survenue, le panier a été écrasé. Si le problème est récurrent, veuillez contacter le support.')
        }
        if(cart && cart.technician && cart.date) {
            await this.getPlannedDay()
        }
    }
}
</script>

<style scoped>

</style>
